'use strict';

module.exports = {
    textColor: {
        default: '#333',
        active: '#FFF'
    },
    selectionColor: '#559FFF',
    todayColor: '#FFA726',
    weekdayColor: '#559FFF',
    headerColor: '#448AFF',
    floatingNav: {
        background: 'rgba(56, 87, 138, 0.94)',
        color: '#FFF',
        chevron: '#FFA726'
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-infinite-calendar/dist/commonjs/theme.js
// module id = 803
// module chunks = 0